export const REQUEST_STATUS = {
  IDLE: 'idle',
  SUCCESS: 'success',
  PENDING: 'pending',
  ERROR: 'error',
};
